import { useState } from "react";

import api from "../../api";

export default function RegisterForm() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleRegister = async (e) => {
    e.preventDefault();

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      await api.post("/api/auth/registration/", {
        first_name: firstName,
        last_name: lastName,
        email,
        password1: password,
        password2: password,
      });

      setSuccess(
        "Registered successfully. You can now log in to your account!"
      );

      setFirstName("");
      setLastName("");
      setEmail("");
      setPassword("");
    } catch (err) {
      const data = err.response?.data;

      let firstError = "";

      if (data) {
        for (const key in data) {
          if (
            Array.isArray(data[key]) &&
            data[key].length > 0
          ) {
            firstError = data[key][0];
            break;
          }
        }
      }

      setError(firstError || "Registration failed");
    }

    setLoading(false);
  };

  return (
    <form
      className="space-y-4"
      onSubmit={handleRegister}
    >
      {/* First Name / Last Name */}
      <div className="grid grid-cols-2 gap-4">
        {/* First Name */}
        <div className="relative w-full">
          <input
            type="text"
            id="first-name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder=" "
            className="
              peer
              w-full
              border border-[#D8C7AD]
              rounded-md
              px-3 pt-5 pb-2
              bg-[#FFFDF8]
              text-[#3B2A1F]
              focus:outline-none
              focus:border-[#A66A2C]
              focus:ring-1
              focus:ring-[#A66A2C]
              transition
            "
            disabled={loading}
            required
          />

          <label
            htmlFor="first-name"
            className="
              absolute left-3 top-3
              text-[#8A7562]
              text-base
              transition-all
              bg-[#FFFDF8]
              px-1

              peer-placeholder-shown:top-3
              peer-placeholder-shown:text-[#9A8977]
              peer-placeholder-shown:text-base

              peer-focus:-top-2
              peer-focus:text-sm
              peer-focus:text-[#8B4A2B]

              peer-[&:not(:placeholder-shown)]:-top-2
              peer-[&:not(:placeholder-shown)]:text-sm
              peer-[&:not(:placeholder-shown)]:text-[#6B4226]

              cursor-text
            "
          >
            First Name
          </label>
        </div>

        {/* Last Name */}
        <div className="relative w-full">
          <input
            type="text"
            id="last-name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            placeholder=" "
            className="
              peer
              w-full
              border border-[#D8C7AD]
              rounded-md
              px-3 pt-5 pb-2
              bg-[#FFFDF8]
              text-[#3B2A1F]
              focus:outline-none
              focus:border-[#A66A2C]
              focus:ring-1
              focus:ring-[#A66A2C]
              transition
            "
            disabled={loading}
            required
          />

          <label
            htmlFor="last-name"
            className="
              absolute left-3 top-3
              text-[#8A7562]
              text-base
              transition-all
              bg-[#FFFDF8]
              px-1

              peer-placeholder-shown:top-3
              peer-placeholder-shown:text-[#9A8977]
              peer-placeholder-shown:text-base

              peer-focus:-top-2
              peer-focus:text-sm
              peer-focus:text-[#8B4A2B]

              peer-[&:not(:placeholder-shown)]:-top-2
              peer-[&:not(:placeholder-shown)]:text-sm
              peer-[&:not(:placeholder-shown)]:text-[#6B4226]

              cursor-text
            "
          >
            Last Name
          </label>
        </div>

        {/* Email */}
        <div className="relative w-full col-span-2">
          <input
            type="email"
            id="register-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder=" "
            className="
              peer
              w-full
              border border-[#D8C7AD]
              rounded-md
              px-3 pt-5 pb-2
              bg-[#FFFDF8]
              text-[#3B2A1F]
              focus:outline-none
              focus:border-[#A66A2C]
              focus:ring-1
              focus:ring-[#A66A2C]
              transition
            "
            disabled={loading}
            required
          />

          <label
            htmlFor="register-email"
            className="
              absolute left-3 top-3
              text-[#8A7562]
              text-base
              transition-all
              bg-[#FFFDF8]
              px-1

              peer-placeholder-shown:top-3
              peer-placeholder-shown:text-[#9A8977]
              peer-placeholder-shown:text-base

              peer-focus:-top-2
              peer-focus:text-sm
              peer-focus:text-[#8B4A2B]

              peer-[&:not(:placeholder-shown)]:-top-2
              peer-[&:not(:placeholder-shown)]:text-sm
              peer-[&:not(:placeholder-shown)]:text-[#6B4226]

              cursor-text
            "
          >
            Email
          </label>
        </div>

        {/* Password */}
        <div className="relative w-full col-span-2">
          <input
            type="password"
            id="register-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder=" "
            className="
              peer
              w-full
              border border-[#D8C7AD]
              rounded-md
              px-3 pt-5 pb-2
              bg-[#FFFDF8]
              text-[#3B2A1F]
              focus:outline-none
              focus:border-[#A66A2C]
              focus:ring-1
              focus:ring-[#A66A2C]
              transition
            "
            disabled={loading}
            required
          />

          <label
            htmlFor="register-password"
            className="
              absolute left-3 top-3
              text-[#8A7562]
              text-base
              transition-all
              bg-[#FFFDF8]
              px-1

              peer-placeholder-shown:top-3
              peer-placeholder-shown:text-[#9A8977]
              peer-placeholder-shown:text-base

              peer-focus:-top-2
              peer-focus:text-sm
              peer-focus:text-[#8B4A2B]

              peer-[&:not(:placeholder-shown)]:-top-2
              peer-[&:not(:placeholder-shown)]:text-sm
              peer-[&:not(:placeholder-shown)]:text-[#6B4226]

              cursor-text
            "
          >
            Password
          </label>
        </div>
      </div>

      {/* Error */}
      {error && (
        <div className="
          text-center
          text-sm
          text-[#9B2C2C]
          bg-[#FCE8E6]
          border
          border-[#F3C4BF]
          rounded-lg
          px-4
          py-3
        ">
          {error}
        </div>
      )}

      {/* Success */}
      {success && (
        <div className="
          text-center
          text-sm
          text-[#527A5A]
          bg-[#EAF4EA]
          border
          border-[#C9DEC9]
          rounded-lg
          px-4
          py-3
        ">
          {success}
        </div>
      )}

      {/* Submit Button */}
      <button
        type="submit"
        disabled={loading}
        className={`
          w-80
          mx-auto
          block
          text-white
          py-3
          rounded-lg
          font-medium
          mt-4
          transition-all
          duration-200
          shadow-sm

          ${
            loading
              ? "bg-[#9A7B62] cursor-not-allowed"
              : "bg-[#7A1F1F] hover:bg-[#5F1818] hover:shadow-md"
          }
        `}
      >
        {loading ? (
          <span className="flex items-center justify-center gap-2">
            Registering

            <span className="flex space-x-1">
              <span className="dot dot1"></span>
              <span className="dot dot2"></span>
              <span className="dot dot3"></span>
            </span>
          </span>
        ) : (
          "Register"
        )}
      </button>
    </form>
  );
}